import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { fetchProducts, fetchProduct } from '../services/productsApi';

const ProductsContext = createContext();

export const useProducts = () => {
  const ctx = useContext(ProductsContext);
  if (!ctx) throw new Error('useProducts must be used within ProductsProvider');
  return ctx;
};

export const ProductsProvider = ({ children }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchProducts();
      setList(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Erro ao carregar produtos');
      setList([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const getProductById = useCallback(
    (id) => list.find((p) => p.id === id),
    [list]
  );

  const getProductByIdOrFetch = useCallback(
    async (id) => {
      const fromList = getProductById(id);
      if (fromList) return fromList;
      try {
        return await fetchProduct(id);
      } catch (_) {
        return null;
      }
    },
    [getProductById]
  );

  const value = {
    products: list,
    loading,
    error,
    refresh: load,
    getProductById,
    getProductByIdOrFetch,
  };

  return (
    <ProductsContext.Provider value={value}>
      {children}
    </ProductsContext.Provider>
  );
};
